import { createSelector } from 'reselect';
import _get from 'lodash/get';
import _has from 'lodash/has';
import _filter from 'lodash/filter';
import _find from 'lodash/find';
import _size from 'lodash/size';
import { getFormValues } from 'redux-form';

import FORM_NAMES from 'constants/formNames';
import { SPECIAL_ENTITIES_NAMES, ENTITY_ANY } from 'constants/rulesTypes';

export const getRulesList = ({ rules }) => rules.list.data.items;

export const getRulesListCount = ({ rules }) => rules.list.data.count;

export const getRule = ({ rules }) => rules.show.data;

export const getIsRuleLoading = ({ rules }) => rules.show.isLoading;

export const getIsLoadingList = ({ rules }) => rules.list.isLoading;

export const getPaginationOptions = ({ rules }) => rules.list.paginationOptions;

export const getIsAdding = ({ rules }) => rules.add.isLoading;

export const getIsDeleting = ({ rules }) => rules.delete.isLoading;

export const getFilterOptions = ({ rules }) => rules.list.filterOptions;

export const getFilterParams = ({ rules }) => rules.list.filterParams;

export const getIsReordering = ({ rules }) => rules.reorder.isLoading;

export const getIsUpdating = ({ rules }) => rules.update.isLoading;

export const getIsExporting = ({ rules }) => rules.partialExport.isLoading;

export const getIsImporting = ({ rules }) => rules.partialImport.isLoading;

export const getImportError = ({ rules }) =>
  _get(rules, 'partialImport.error.response.data', {});

export const getIsPartialUpdating = ({ rules }) =>
  rules.partialUpdate.isLoading;

export const getFilterOptionsWithSelected = createSelector(
  getFilterOptions,
  getPaginationOptions,
  (filterOptions, paginationOptions) =>
    filterOptions.map(option => ({
      ...option,
      selected: option.archived === paginationOptions.archived,
    })),
);

export const getSelectedFilteredOption = createSelector(
  getFilterOptionsWithSelected,
  filterOptions => filterOptions.find(({ selected }) => selected === true),
);

export const getRulesMatchedListId = createSelector(
  getRulesList,
  list => _filter(list, 'matchedRows').map(({ id }) => id),
);

// showOnlyMatchedRules
export const getMatchedFilterOption = createSelector(
  getFilterOptions,
  filterOptions => _find(filterOptions, { type: 'matched' }).value,
);

export const getHasSelectedRule = ({ rules }) => _has(rules.show.data, 'id');

export const getMatchingPatternEntities = createSelector(
  getFormValues(FORM_NAMES.RULES.INSPECT),
  form => (form && form.entities) || [],
);

export const hasMandatoryMPE = createSelector(
  getMatchingPatternEntities,
  entities => {
    if (_size(entities)) {
      return entities.some(entity => entity.mandatory);
    }
    return true;
  },
);

export const getFilteredEntities = createSelector(
  getMatchingPatternEntities,
  entities => {
    if (_size(entities)) {
      return entities.filter(
        ({ name }) => !SPECIAL_ENTITIES_NAMES.includes(name),
      );
    }
    return [];
  },
);

export const getFilteredConditionsEntities = createSelector(
  getMatchingPatternEntities,
  entities => {
    if (_size(entities)) {
      return entities.filter(({ name }) => name !== ENTITY_ANY);
    }
    return [];
  },
);
